module.exports = __webpack_public_path__ + "img/success.16818c4d.png";